<script setup lang="ts">
import { useRouter } from 'vue-router';
import BankingWrapper from '@/application/layouts/ContentWrapper/BankingWrapper.vue';
import { useTagManager } from '@demv_systems/feu-tag-manager';
import { TrackEventCategory } from '@/application/utils/tracking/events';

const router = useRouter();

async function onOpenCategory(e: CustomEvent) {
  const { category } = e.detail;
  useTagManager().push({ event: TrackEventCategory.BANKS_API, action: 'openCategory' });
  await router.push(`/banking/budget-analysis/category/${category}`);
}

async function onOpenCategoryTransactions(e: CustomEvent) {
  const { category } = e.detail;
  useTagManager().push({ event: TrackEventCategory.BANKS_API, action: 'openCategoryTransactions' });
  await router.push(`/banking/budget-analysis/category/${category}/transactions`);
}

async function onOpenTimePeriodChange() {
  useTagManager().push({ event: TrackEventCategory.BANKS_API, action: 'timePeriodChange' });
}
</script>

<template>
  <BankingWrapper v-slot="{ token, onEmitError }">
    <!-- eslint-disable vue/v-on-event-hyphenation -->
    <ba-budget-analysis
      :token="token"
      @emitError="(e) => onEmitError(e, 'ba-budget-analysis')"
      @timePeriodChange="onOpenTimePeriodChange"
      @openCategoryTransactions="onOpenCategoryTransactions"
      @openCategory="onOpenCategory"
    />
  </BankingWrapper>
</template>
